import { StudentDetails } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function fetchStudentInfo(studentNo: string) {
    try {
        const response = await portalApi.get<StudentDetails>(`/students/${studentNo}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching student info:", error);
        throw error;
    }
}
